import React, { Component } from 'react'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'

import 'styles/mobistyle/mobi.css'
import { formatPercentageWithoutLimit, isDefined } from '../../utils/masks'
import Mask from 'vanilla-masker'
import Button from '../Button'
import { Object } from 'core-js'
import { isEmpty } from 'utils/validations'

const CHECKED = 1
const UNCHECKED = 0
const MAX_LENGTH_PERCENTUAL = 9

class bodyParameters extends Component {
  static propTypes = {
    translate: PropTypes.func,
    submit: PropTypes.func.isRequired,
    allParameters: PropTypes.object.isRequired,
    fieldsDisabled: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      parameters: {
        ...{
          qqChanges: '0',
          qqDay: '0',
          qqStockLimit: '0',
          valueLimit: '00,00',
        },
        ...this.props.allParameters
      },
      saveDisabled: true,
    }
  }

  componentDidUpdate(prevProps) {
    /* istanbul ignore else */
    if (this.props.allParameters !== prevProps.allParameters) {
      this.atualizarComponente()
    }
  }

  atualizarComponente() {
    if (this.props.allParameters.valueAdjust) {
      this.props.allParameters.valueAdjust = this.moneyMask(
        this.props.allParameters.valueAdjust
      )
    }
    if (this.props.allParameters.valueLimit) {
      this.props.allParameters.valueLimit = this.moneyMask(
        this.props.allParameters.valueLimit
      )
    }
      if(Object.keys(this.props.allParameters).length  > 0) this.setState({ parameters: this.props.allParameters })
    
    if (isEmpty(this.props.allParameters)){
      this.handleReset()
    }
  }

  updateParameters(event, fieldName) {

    const isInvalidChanges =
      fieldName === null ||
      event === null ||
      event.target === null ||
      event.target.value === undefined
    /* istanbul ignore else */
    if (isInvalidChanges) {
      return
    }

    const { parameters } = this.state

    if (['valueAdjust', 'valueLimit'].indexOf(fieldName) !== -1) {
      event.target.value = this.moneyMask(event.target.value.replace(',', ''))
    }

    parameters[fieldName] = event.target.value

    this.setState({ parameters, saveDisabled: false })
  }

  updateParametersCheckbox(value) {
    this.setState((state) => ({
      parameters: {
        ...state.parameters,
        [value]: state.parameters[value] === CHECKED ? UNCHECKED : CHECKED,
      },
      saveDisabled: false,
    }))
  }

  handleReset = () => {
    const {idIrcAutonomousParameter} = this.props.allParameters
    this.setState(() => ({
      parameters: {
        idIrcAutonomousParameter: idIrcAutonomousParameter || null,
        qqChanges: '0',
        qqDay: '0',
        qqStockLimit: '0',
        valueLimit: '00,00',
      },
      saveDisabled: false,
    }))
  }

  moneyMask = (value) => {
    if (!isDefined(value)) {
      value = '00,00'
    }
    return Mask.toMoney(value.replace(',', ''), { precision: 2 })
  }

  checkedValue = (value) => (value === 1 ? 'checked' : '')

  disableSaveOnSubmit = () => this.setState({saveDisabled: true})

  onSubmit = (parameters) => {
    const {submit} = this.props
    submit(parameters)
    this.disableSaveOnSubmit()
  }

  render() {
    const { translate, fieldsDisabled } = this.props
    const { parameters, saveDisabled } = this.state

    return (
      <div className={'container parameters-per-store-form'}>
        <form className='parametersForm'>
          <span className={'title'}>{translate('mobile.ponctual.title')}</span>
          <div className={'mobiCard'}>
            <table cellPadding='0' cellSpacing='0' className='new-table'>
              <thead>
                <tr>
                  <th scope={'col'} colSpan='1'>
                    Parâmetro
                  </th>
                  <th colSpan='4' className='text-center'>
                    Valores
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className={'mobiItem'}>
                  <td id={'part1'}>
                    {translate('parameters.autonomous.part1')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqChanges'}
                      placeholder={parameters.qqChanges ? parameters.qqChanges : '0'}
                      maxLength={2}
                      value={parameters.qqChanges}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqChanges')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>

                  <td className={'label-td'} id={'part2'}>
                    {translate('parameters.autonomous.part2')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqDay'}
                      placeholder={parameters.qqDay ? parameters.qqDay : '0'}
                      maxLength={2}
                      value={parameters.qqDay}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqDay')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td className={'label-td'} id={'part3'}>
                    {translate('parameters.autonomous.part3')}
                  </td>
                </tr>

                <tr className={'mobiItem'}>
                  <td id={'part4'}>
                    {translate('parameters.autonomous.part4')}
                  </td>
                  <td>
                    {' '}
                    <input
                      id={'qqStockLimit'}
                      maxLength={MAX_LENGTH_PERCENTUAL}
                      placeholder={parameters.qqStockLimit ? parameters.qqStockLimit : '0'}
                      value={formatPercentageWithoutLimit(parameters.qqStockLimit)}
                      onChange={(event) =>
                        this.updateParameters(event, 'qqStockLimit')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />{' '}
                  </td>
                  <td id={'part5'}>
                    {translate('parameters.autonomous.part5')}
                  </td>
                </tr>
                
                <tr className={'mobiItem'}>
                  <td id={'part6'}>
                    {translate('parameters.autonomous.part6')}
                  </td>
                  <td>
                    <input
                      id={'valueLimit'}
                      maxLength={10}
                      placeholder={parameters.valueLimit ? parameters.valueLimit : '0'}
                      value={parameters.valueLimit}
                      onChange={(event) =>
                        this.updateParameters(event, 'valueLimit')
                      }
                      className='form-control'
                      type='input'
                      disabled={fieldsDisabled} 
                    />
                  </td>
                  <td className={'label-td'} colSpan={3}>
                    {translate('option.currency.name')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

    
          <div className={'box-btn'}>
            <Button
              role='button'
              type='button'
              className='btn btn-w btn-danger-outline margin-right'
              text={translate('clear_button_label')}
              onClick={this.handleReset}
              disabled={fieldsDisabled} // Desabilitar checkbox
            />
            <Button
              role='button'
              type='button'
              className='btn btn-w btn-primary margin-right'
              disabled={fieldsDisabled || saveDisabled} 
              onClick={() => this.onSubmit(parameters)}
              text={translate('save_button_label')}
            />
          </div>
        </form>
      </div>
    )
  }
}

/* istanbul ignore next */
translate(null, { wait: true, translateFuncName: 'translate' })(bodyParameters)
export default bodyParameters
export { bodyParameters }
